import { RevisionPlanRow } from 'components/tables/data/revision-plan/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the device ID.
 */
export default function DeviceIdColumn({ data: { deviceId } }: { data: RevisionPlanRow }) {
  return <P3Regular color="gray.8">{deviceId}</P3Regular>;
}
